import { useRef } from 'react';
import HeroSection from '../../sections/HeroSection/HeroSection';
import { ThemeProvider } from 'styled-components';
import theme from '../../global/theme';
import ContactSection from '../../sections/ContactSection/ContactSection';
import CaseStudySection from '../../sections/CaseStudySection/CaseStudySection';
import { GlobalStyle } from '../../global/global';
import StyledButton from '../../components/Button/Button';
import { Box, Flex, Text, Image, Heading, Hide, Show } from '@chakra-ui/react';
import SubscriptionSection from '../../sections/SubscriptionSection/SubscriptionSection';
import { StyledHeading } from '../../sections/ContactSection/styles';
import { List, ListItem, ListIcon } from '@chakra-ui/react';
import { CheckIcon } from '@chakra-ui/icons';
import CTASection from '../../sections/CalltoActionSection/CalltoActionSection';
import { ImplementationTable } from './implementationTable';

const scrollToSection = (ref: React.RefObject<HTMLDivElement>) => {
    ref.current?.scrollIntoView({ behavior: 'smooth' });
};

interface Props {}
export default function ImplementationPage(props: Props) {
    const sectionAbonamentyRef = useRef(null);
    return (
        <ThemeProvider theme={theme}>
            <GlobalStyle $whiteColor />
            <HeroSection
                title="Wdrożymy Twój sklep internetowy IdoSell"
                subTitle="Sprawdź co możemy dla Ciebie zrobić. 
W IdoSell dajemy Ci wiele możliwości personalizacji sklepu."
                image={{
                    url: 'https://www.idosell.com/panel/file-gate.php?id=302431&ext=.webp',
                    alt: 'Zdjęcie wyróżniające w hero - strona pakietów wdrożeniowych',
                }}
                buttons={[
                    {
                        title: 'Zamów sklep',
                        href: 'https://www.idosell.com/pl/abonamenty/',
                        variant: 'default',
                    },
                ]}
            />

            <div className="homepage containerIdosellPages">
                <Box
                    my={{
                        base: 16,
                        md: 20,
                        xl: 24,
                    }}
                    display={'flex'}
                    flexDirection={'column'}
                    gap={{
                        base: 20,
                        md: 24,
                    }}
                >
                    <Box ref={sectionAbonamentyRef}>
                        <ImplementationTable />
                    </Box>

                    <CTASection
                        title="Odkryj możliwości IdoSell"
                        subtitle="Poznaj nasz panel, odkryj naszą technologię, otwórz lub migruj sklep i zacznij sprzedawać więcej."
                        buttons={[
                            {
                                title: 'Zamów sklep',
                                href: 'https://www.idosell.com/pl/order/',
                                variant: 'default',
                            },
                        ]}
                    />
                    <ContactSection />
                </Box>
            </div>
        </ThemeProvider>
    );
}
